/**
 * COMPONENT: AssignUserButton
 * Bouton pour ouvrir la modale d'assignation d'utilisateur
 */

import { useState } from 'react';
import { User, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';
import { AssignUserModal } from '../modals/AssignUserModal';

interface AssignUserButtonProps {
  assignedUserId: string | null;
  assignedUserName: string | null;
  onAssign: (userId: string) => Promise<void>;
  onUnassign?: () => Promise<void>;
  recentUserIds?: string[];
  disabled?: boolean;
}

export function AssignUserButton({
  assignedUserId,
  assignedUserName,
  onAssign,
  onUnassign,
  recentUserIds = [],
  disabled = false,
}: AssignUserButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button variant="outline" size="sm" disabled={disabled} onClick={() => setIsModalOpen(true)}>
        <User className="h-4 w-4 mr-2" />
        {assignedUserName || 'Non assigné'}
        <ChevronDown className="h-4 w-4 ml-2" />
      </Button>

      <AssignUserModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currentUserId={assignedUserId}
        onAssign={onAssign}
        onUnassign={onUnassign}
        recentUserIds={recentUserIds}
        showUnassignOption={!!onUnassign}
      />
    </>
  );
}
